<template>
    <div>
        <b-card style="border: none; margin-left: 2rem; margin-right: 2rem">
            <b-row>
                <b-col class="pr-0">
                    <b-button variant="primary" v-on:click="onBack" class="px-4 float-right mb-2">Zurück
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-if="!is_map_mode">
                <b-col style="height: 65vh; overflow: auto">
                    <b-table striped hover selectable :items="groups" :fields="group_fields"
                             select-mode="single"
                             selectedVariant="primary"
                             @row-selected="rowSelectedGroup"
                             ref="group_table"
                    ></b-table>
                </b-col>
            </b-row>
            <b-row v-if="is_map_mode">
                <b-col class="pl-0"><h5>Georeferenzierung für: {{geoObjectName}}</h5></b-col>
                <b-col class="pr-0">
                    <b-button variant="success" :disabled="selected.length === 0 && !preselect" v-on:click="onSave" class="px-4 float-right ml-2 mb-2">Speichern
                    </b-button>
                    <b-button variant="warning" v-on:click="toggleMap(null)" class="px-4 float-right mb-2" v-if="!preselect">Auftragsgruppe wählen
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-if="is_map_mode">
                <b-col style="height: 65vh; overflow: auto" v-if="!preselect">
                    <b-table striped hover :items="objects" :fields="object_fields"
                             ref="object_table"
                             selectable
                             select-mode="single"
                             selectedVariant="primary"
                             @row-selected="rowSelectedObject"
                    >
                        <!--template v-slot:cell(gps)="row">
                            <b-button style="float: right;" variant="primary" size="sm"
                                      @click="toggleMap(row.item)">
                                Referenzieren
                            </b-button>
                        </template-->
                    </b-table>
                </b-col>
                <b-col style="height: 65vh; padding: 0; margin-bottom: 0" id="map_container"
                       ref="map_container">
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
    import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";

    import StylesControl from 'mapbox-gl-controls/lib/styles';
    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';

    import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
    import MapboxDraw from '@mapbox/mapbox-gl-draw'
    import {styles} from '../geo_referencing/draw_style'

    export default {
        name: "geo_referencing",
        mounted() {
          this.showLoader();
          this.gps = undefined;
          this.places = undefined;
          this.placesMap = {};
          this.gpsMap = {};
          if (this.$route.query.aufisn) {
            this.preselect = this.$route.query.aufisn;
            this.$http.get(
                Server_URL+'/auftragsbuch/data/geo_referencing/'+this.preselect
            ).then(this.responseOkPreselect, this.responseError)
          } else {
            this.$http.get(
                Server_URL+'/auftragsbuch/data/geo_referencing'
            ).then(this.responseOkGet, this.responseError)
          }
        },
        data() {
            return {
                loader: undefined,
                currentGroup: {},
                groups: [],
                objects: undefined,
                objectsMap: {},
                //places: undefined,
                currentGps: null,
                currentPlace: null,
                //gpsMap: {},
                //placesMap: {},
                group_fields: [{key: "titel", label: 'Gruppe wählen'}],
                object_fields: [{key: "gi_match", label: 'Objekt wählen'}, {key: "has_gps", label: "Bereits Referenziert ?", formatter: (value, key, item) => {
                        if (item === null) {
                            return "Nein";
                        }
                        if (this.gps !== undefined && this.gps !== null && this.gps.length > 0) {
                            for (let i = 0; i < this.gps.length; i++) {
                                let cur = this.gps[i];
                                if (cur.stamm_auftrag === item.gi_aufisn) {
                                    return "Ja";
                                }
                            }
                        }
                        return "Nein"
                    }}, {key: "gps", label: ""}],
                selected: [],

                // todo use later
                commune: "",

                settings: {},
                selected_group: {},
                is_map_mode: false,
                isInitial: true,
                geoRefPerimeter: "",
                geoObjectName: "",
                preselect: '',
            }
        },
        methods: {
            rowSelectedGroup(items) {
                this.geoObjectName = "";
                if (items.length === 0) {
                    this.objects = undefined;
                    this.selected = [];
                    this.currentGroup = {};
                    this.gps = undefined;
                    this.places = undefined;
                    this.currentGps = null;
                    this.currentPlace = null;
                } else {
                    this.objects = this.objectsMap[items[0].key];
                    this.gps = this.gpsMap[items[0].key];
                    this.places = this.placesMap[items[0].key];
                    this.currentGroup = items[0];
                    this.toggleMap();
                }
            },
            rowSelectedObject(items) {
              console.time('doSomething')

              this.selected = items;
                this.currentGps = null;
                this.currentPlace = null;
                if (this.geocoder !== undefined) {
                    this.geocoder.clear();
                    this.geocoder.setInput("");
                }
                if (items.length > 0 && this.places !== undefined && this.places !== null && this.places.length > 0) {
                    let obj = items[0];
                    for (let i = 0; i < this.places.length; i++) {
                        let cur = this.places[i];
                        if (cur.stamm_auftrag === obj.gi_aufisn) {
                            this.currentPlace = cur;
                            break;
                        }
                    }
                }
                if (items.length > 0 && this.gps !== undefined && this.gps !== null && this.gps.length > 0) {
                    this.geoObjectName = this.selected[0].gi_match;
                    let obj = items[0];
                    for (let i = 0; i < this.gps.length; i++) {
                        let cur = this.gps[i];
                        if (cur.stamm_auftrag === obj.gi_aufisn) {
                            this.currentGps = cur;
                            break;
                        }
                    }
                }
              console.timeEnd('doSomething')
              if (items.length > 0 ) {
                    this.addGpsData();
                }
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200 && response.body.status === "ok") {
                    for (let i = response.body.data.augrs.length-1; i >= 0; i--) {
                        if (response.body.data.aufisn_map[response.body.data.augrs[i].key] === undefined) {
                            response.body.data.augrs.splice(i, 1)
                        }
                    }
                    this.groups = response.body.data.augrs;
                    this.objectsMap = response.body.data.aufisn_map;
                    this.gpsMap = response.body.data.gps_map;
                    this.placesMap = response.body.data.gps_places_map;
                    this.geoRefPerimeter = response.body.data.geo_ref_perimeter;
                    if (this.groups.length === 1) {
                        this.$nextTick(() => {
                            this.$refs.group_table.selectRow(0);
                        });
                    }
                } else {
                    window.location = Redirect_500;
                }
            },
          responseOkPreselect(response) {
            this.hideLoader();
            if (response.status === 200 && response.body.status === "ok") {
              this.selected = [response.body.data.aufisn];
              if (response.body.data.gps.id !== '') {
                this.gps = [response.body.data.gps];
              }
              if (response.body.data.gps_places.id !== '') {
                this.places = [response.body.data.gps_places];
              }
              this.geoRefPerimeter = response.body.data.geo_ref_perimeter;
              this.toggleMap();
              //this.rowSelectedObject(this.selected);
            } else {
              window.location = Redirect_500;
            }
          },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            },
            toggleMap(item) {
                if (item !== undefined && item !== null) {
                    this.selected = [item];
                    if (this.selected.length > 0 && this.gps !== undefined && this.gps !== null && this.gps.length > 0) {
                        let obj = this.selected[0];
                        for (let i = 0; i < this.gps.length; i++) {
                            let cur = this.gps[i];
                            if (cur.stamm_auftrag === obj.gi_aufisn) {
                                this.currentGps = cur;
                                break;
                            }
                        }
                    }
                } else {
                    this.currentGps = null;
                    this.currentPlace = null;
                }
                this.geoObjectName = "";
                this.lat = null;
                this.lon = null;
                let current = this.is_map_mode;
                this.is_map_mode = !this.is_map_mode;
                this.isInitial = true;
                if (!current) {
                    setTimeout(() => {
                        mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
                        this.map = new mapboxgl.Map({
                            container: 'map_container',
                            style: 'mapbox://styles/mapbox/outdoors-v11',
                            center: [10.244990, 50.943359],
                            zoom: 6,
                            minZoom: 5,
                            maxZoom: 19,
                            maxPitch: 0,
                        });
                        this.draw = new MapboxDraw({
                            displayControlsDefault: false,
                            controls: {
                                point: true,
                                line_string: true,
                                polygon: true,
                                trash: true,
                            },
                            styles: styles
                        });
                        this.map.addControl(new StylesControl({
                            styles: [
                                {
                                    label: 'Normal',
                                    styleName: 'Mapbox Streets',
                                    styleUrl: 'mapbox://styles/mapbox/outdoors-v11',
                                }, {
                                    label: 'Satellit',
                                    styleName: 'Satellite',
                                    styleUrl: 'mapbox://styles/mapbox/satellite-streets-v11',
                                },
                            ],
                            onChange: () => this.map.once("style.load", this.queryPlace),
                        }), 'top-left');
                        this.map.addControl(this.draw, 'top-left');
                        this.map.addControl(new ZoomControl(), 'bottom-right');
                        const languageControl = new LanguageControl({
                            language: 'de',
                        });
                        this.map.addControl(languageControl);
                        this.geocoder = new MapboxGeocoder({
                            accessToken: mapboxgl.accessToken,
                            mapboxgl: mapboxgl,
                            placeholder: "Suchen",
                            zoom: 19,
                            language: 'de-DE',
                            countries: 'de',
                            marker: false,
                            flyTo: true,
                        });
                        this.geocoder.on("result", (res) => {
                            if (!this.hasGeometry() && this.selected.length > 0) {
                                let coords = res.result.center;
                                let feature = {
                                    type: 'Feature',
                                    properties: {
                                        id: ""
                                    },
                                    geometry: {
                                        type: 'Point',
                                        coordinates: coords
                                    }
                                };
                                this.draw.add(feature);
                                setTimeout(() => {
                                    this.draw.changeMode("simple_select", {
                                        featureIds: [this.draw.getAll().features[0].id]
                                    });
                                });
                            } else {
                                console.log("could not make point")
                            }
                        });
                        this.map.addControl(
                            this.geocoder
                        );
                        //this.map.on('click', this.onMapClick);
                        this.map.once('load', this.queryPlace)
                    });
                } else {
                    this.lat = null;
                    this.lon = null;
                    this.marker = null;
                    this.map.remove();
                    this.rowSelectedGroup([]);
                }
            },
            queryPlace() {
                setTimeout(() => {
                    this.map.resize();
                    if (this.isInitial && this.preselect) {
                      this.isInitial = false;
                      this.rowSelectedObject(this.selected);
                    } else if (this.isInitial) {
                        this.map.on('draw.modechange', this.onModeChange);
                        this.isInitial = false;
                        if (this.geoRefPerimeter !== "") {
                            setTimeout(() => {
                                    let sw = this.geoRefPerimeter.split("||")[0].split(",");
                                    let ne = this.geoRefPerimeter.split("||")[1].split(",");
                                    this.map.fitBounds([
                                        [parseFloat(sw[0]), parseFloat(sw[1])], // southwestern corner of the bounds
                                        [parseFloat(ne[0]), parseFloat(ne[1])] // northeastern corner of the bounds
                                    ], {padding: 100, duration: 500});
                            });
                        }
                    }
                });
            },
            addGpsData() {
              console.time('addGps')

              this.draw.deleteAll();
                this.draw.changeMode("simple_select");
                let bounds = null;
                let searchQuery = "";
                if (this.currentGps !== null) {
                    if (this.currentGps.wkt.startsWith("POLYGON")) {
                        bounds = this.addPolygon();
                    } else if (this.currentGps.wkt.startsWith("LINESTRING")) {
                        bounds = this.addLineString();
                    } else if (this.currentGps.wkt.startsWith("POINT")) {
                        bounds = this.addPoint();
                    }
                } else if (this.currentPlace !== null && this.currentPlace.strasse_hnr !== "" && this.currentPlace.plz !== "") {
                    searchQuery += this.currentPlace.strasse_hnr + ", " + this.currentPlace.plz + " " + this.currentPlace.ort
                }

                if (this.geoRefPerimeter !== "" || bounds !== null || searchQuery !== "") {
                    setTimeout(() => {
                        if (bounds !== null) {
                            this.map.fitBounds(bounds, {padding: 100, duration: 500});
                        } else if (searchQuery !== "") {
                            this.geocoder.query(searchQuery);
                        } else {
                            let sw = this.geoRefPerimeter.split("||")[0].split(",");
                            let ne = this.geoRefPerimeter.split("||")[1].split(",");
                            this.map.fitBounds([
                                [parseFloat(sw[0]), parseFloat(sw[1])], // southwestern corner of the bounds
                                [parseFloat(ne[0]), parseFloat(ne[1])] // northeastern corner of the bounds
                            ], {padding: 100, duration: 500});
                        }
                    });
                }
              console.timeEnd('addGps')
            },
            onModeChange(mode) {
              if (mode.mode.startsWith("draw_") && this.draw.getAll().features.length > 1) {
                  this.draw.changeMode("simple_select", {
                      featureIds: [this.draw.getAll().features[0].id]
                  });
                  this.$bvToast.toast("Bitte löschen Sie zuerst Ihre bisherige Selektion um neu beginnen zu können.", {
                      title: 'Achtung',
                      autoHideDelay: 3000,
                      appendToast: false,
                      toaster: 'b-toaster-top-center',
                      variant: 'warning',
                      solid: true
                  })
              }
            },
            addPolygon() {
                let poly = this.currentGps.wkt;
                if (poly.includes("\\r\\n")) {
                    poly = poly.split("\\r\\n")[0];
                }
                poly = poly.replace("POLYGON(", "");
                poly = poly.replace(")", "");
                let splits = poly.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                coords.push(coords[0]);
                let feature = {
                        type: 'Feature',
                    properties: {
                        id: this.currentGps.id
                    },
                        geometry: {
                            type: 'Polygon',
                            coordinates: [
                                coords
                            ]
                        }
                    };
                this.draw.add(feature);
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            addLineString() {
                let line = this.currentGps.wkt;
                if (line.includes("\\r\\n")) {
                    line = line.split("\\r\\n")[0];
                }
                line = line.replace("LINESTRING(", "");
                line = line.replace(")", "");
                let splits = line.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                let feature = {
                    type: 'Feature',
                    properties: {
                        id: this.currentGps.id
                    },
                    geometry: {
                        type: 'LineString',
                        coordinates: coords
                    }
                };
                this.draw.add(feature);
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            addPoint() {
                let point = this.currentGps.wkt;
                if (point.includes("\\r\\n")) {
                    point = point.split("\\r\\n")[0];
                }
                point = point.replace("POINT(", "");
                point = point.replace(")", "");
                let splits = point.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                let feature = {
                    type: 'Feature',
                    properties: {
                        id: this.currentGps.id
                    },
                    geometry: {
                        type: 'Point',
                        coordinates: coords[0]
                    }
                };
                this.draw.add(feature);
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            onBack() {
                window.history.back();
            },
            hasGeometry() {
                if (this.draw.getAll().length < 1 || this.draw.getAll().features.length < 1) {
                    return false;
                }
                let feature = this.draw.getAll().features[0];
                switch (feature.geometry.type) {
                    case "Polygon":
                        return feature.geometry.coordinates[0].length >= 4;

                    case "LineString":
                        return feature.geometry.coordinates.length >= 2;

                    case "Point":
                        return feature.geometry.coordinates.length === 2;

                }
                return false;
            },
            onSave() {
                if (this.draw.getAll().features.length === 0) {
                    this.$bvToast.toast("Bitte treffen Sie zuerst eine Selektion.", {
                        title: 'Achtung',
                        autoHideDelay: 3000,
                        appendToast: false,
                        toaster: 'b-toaster-top-center',
                        variant: 'warning',
                        solid: true
                    });
                    return;
                }
                let feature = this.draw.getAll().features[0];
                let currId = "";
                if (this.currentGps !== undefined && this.currentGps !== null) {
                    currId = this.currentGps.id;
                }
                let obj = this.selected[0];
                let payload  = {
                    id: currId,
                    augr: obj.gi_augr,
                    aufisn: obj.gi_aufisn,
                    name: obj.gi_match,
                    type: "",
                    coords: []

                };
                switch (feature.geometry.type) {
                    case "Polygon":
                        if (feature.geometry.coordinates[0].length < 4) {
                            this.$bvToast.toast("Bitte treffen Sie zuerst eine Selektion.", {
                                title: 'Achtung',
                                autoHideDelay: 3000,
                                appendToast: false,
                                toaster: 'b-toaster-top-center',
                                variant: 'warning',
                                solid: true
                            });
                            return;
                        }
                        payload.type = "POLYGON";
                        for (let i = 0; i < feature.geometry.coordinates[0].length-1; i++) {
                            payload.coords.push(feature.geometry.coordinates[0][i]);
                        }
                        break;
                    case "LineString":
                        if (feature.geometry.coordinates.length < 2) {
                            this.$bvToast.toast("Bitte treffen Sie zuerst eine Selektion.", {
                                title: 'Achtung',
                                autoHideDelay: 3000,
                                appendToast: false,
                                toaster: 'b-toaster-top-center',
                                variant: 'warning',
                                solid: true
                            });
                            return;
                        }
                        payload.type = "LINESTRING";
                        for (let i = 0; i < feature.geometry.coordinates.length; i++) {
                            payload.coords.push(feature.geometry.coordinates[i]);
                        }
                        break;
                    case "Point":
                        if (feature.geometry.coordinates.length !== 2) {
                            this.$bvToast.toast("Bitte treffen Sie zuerst eine Selektion.", {
                                title: 'Achtung',
                                autoHideDelay: 3000,
                                appendToast: false,
                                toaster: 'b-toaster-top-center',
                                variant: 'warning',
                                solid: true
                            });
                            return;
                        }
                        payload.type = "POINT";
                        payload.coords.push(feature.geometry.coordinates);
                        break;
                }
                this.showLoader();
                this.$http.post(
                    Server_URL + '/auftragsbuch/data/geo_referencing',
                    payload
                ).then(this.responseOkPost, this.responseError)
            },
            responseOkPost(response) {
                this.hideLoader();
                if (response.status === 200 && response.body.status === "ok") {
                    if (this.preselect) {
                      this.$router.go(-1);
                      return
                    }
                    let gpsResponse = response.body.data;
                    this.currentGps = gpsResponse;
                    if (this.gps === undefined || this.gps === null) {
                        this.gps = [gpsResponse];
                    } else {
                        for (let i = 0; i < this.gps.length; i++) {
                            if (this.gps[i].id === gpsResponse.id) {
                                this.gps.splice(i, 1);
                                break;
                            }
                        }
                        this.gps.push(gpsResponse);
                    }
                    this.gpsMap[this.currentGroup.key] = this.gps;
                    this.draw.changeMode("simple_select");
                    this.$bvToast.toast('Die Änderungen wurden erfolgreich gespeichert.', {
                        title: 'Gespeichert',
                        variant: 'success',
                        solid: true
                    })
                } else {
                    window.location = Redirect_500;
                }
            }
        }
    }
</script>

<style>
    .marker {
        background-image: url('../../../public/mangel_marker.png');
        background-size: cover;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;
    }

    .form-control:disabled {
        color: black;
    }

    .text-black {
        color: black;
    }
</style>
